<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <form role="form" v-on:submit="search">
        <div class="search row">
          <div class="dropdown"></div>
          <div class="col-lg-4 pt-0 pl-0 pr-2">
            <base-input
              alternative=""
              label=""
              placeholder="ข้อมูลที่ต้องการค้นหา"
              input-classes="form-control-alternative"
              v-model="keyword"
            />
          </div>
          <input
            type="submit"
            class="btn btn-primary mt--2 mt-md-0 mb-md-4"
            value="ค้นหาข้อมูล"
          />
        </div>
      </form>
      <div class="row">
        <div class="col">
          <agent-table
            title="ตัวแทนทั้งหมด"
            :agents="agents"
          ></agent-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import AgentTable from "./Tables/AgentTable";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "agent",
  mixins: [kickMixin],
  components: {
    AgentTable,
  },
  data() {
    return {
      keyword: "",
      agents: [],
    };
  },
  methods: {
    loadAgents: function() {
      var localApp = this;
      axios
        .get("/api/agent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.agents = response.data.data;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    search: async function(e) {
      let localApp = this;
      e.preventDefault();

      await axios
        .get(
          "/api/agent/search/q?keyword=" +
            localApp.keyword,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.agents = response.data.data;
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadAgents();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
a {
  cursor: pointer;
}
</style>
